module.exports = __webpack_public_path__ + "img/commitment.2f78f430.svg";